import { render } from "./PurchaseCard.vue?vue&type=template&id=5dae47e4"
import script from "./PurchaseCard.vue?vue&type=script&lang=js"
export * from "./PurchaseCard.vue?vue&type=script&lang=js"

import "./PurchaseCard.vue?vue&type=style&index=0&id=5dae47e4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__